import { FormDialog } from 'components/dialog/form'
import { SearchsDrugResult, useEditSearchsDrug } from 'interface/search/drug'
import { useSearchsDrugForm, SearchsDrugForm } from '../form'

type EditSearchsDrugDialogProps = {
  searchId: number
  drug: SearchsDrugResult
  onSubmit: (result: SearchsDrugResult) => void
  onClose: () => void
}
export const EditSearchsDrugDialog = ({
  searchId,
  drug,
  onSubmit,
  onClose
}: EditSearchsDrugDialogProps) => {
  const [postState, submit] = useEditSearchsDrug(searchId, drug.searchsDrugId, { onEditted: onSubmit })
  const form = useSearchsDrugForm({ data: drug, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title={drug.drugName}
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsDrugForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
